import React, { useContext } from "react";
import XLabelField from "component/labelField/XLabelField";
import { CertificationSessionInterface } from "module/certification/types";
import CertificationSessionContext from "module/certificationSession/context/CertificationSessionContext";

const CertificationSessionRemarksFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationSessionContext);

  const certificationSessions = entity as CertificationSessionInterface;

  return <XLabelField {...{ label: certificationSessions.remarks }} />;
};

export default React.memo(CertificationSessionRemarksFieldContainer);
